"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.accordion = void 0;
require("../scss/main.scss");
var Accordion_1 = __importDefault(require("./components/Accordion"));
var Dop_1 = __importDefault(require("./components/Dop"));
var FaqFilter_1 = __importDefault(require("./components/FaqFilter"));
var FileUpload_1 = __importDefault(require("./components/FileUpload"));
var Filter_1 = __importDefault(require("./components/Filter"));
var FloatingLabels_1 = __importDefault(require("./components/FloatingLabels"));
var LanguageSwitch_1 = __importDefault(require("./components/LanguageSwitch"));
var MainMenu_1 = __importDefault(require("./components/MainMenu"));
var Modal_1 = __importDefault(require("./components/Modal"));
var Poll_1 = __importDefault(require("./components/Poll"));
var ProductDownloads_1 = __importDefault(require("./components/ProductDownloads"));
var ProductFilter_1 = __importDefault(require("./components/ProductFilter"));
var ReferencesList_1 = __importDefault(require("./components/ReferencesList"));
var ScrollToTop_1 = __importDefault(require("./components/ScrollToTop"));
var SplideSlider_1 = __importDefault(require("./components/SplideSlider"));
var ZipSearch_1 = __importDefault(require("./components/ZipSearch"));
var copyToClipboard_1 = require("./helpers/copyToClipboard");
var scrollDetector_1 = require("./helpers/scrollDetector");
var videoPlayer_1 = require("./helpers/videoPlayer");
document.addEventListener('DOMContentLoaded', function () {
    exports.accordion = new Accordion_1.default();
    new Dop_1.default();
    new FaqFilter_1.default();
    new FileUpload_1.default();
    new Filter_1.default();
    new FloatingLabels_1.default();
    new LanguageSwitch_1.default();
    new MainMenu_1.default();
    new Modal_1.default();
    new Poll_1.default();
    new ProductDownloads_1.default();
    new ProductFilter_1.default();
    new ReferencesList_1.default();
    new ScrollToTop_1.default();
    // new SolrAutocomplete();
    new SplideSlider_1.default();
    new ZipSearch_1.default();
    (0, copyToClipboard_1.copyToClipboard)();
    (0, scrollDetector_1.scrollDetector)();
    (0, videoPlayer_1.videoPlayer)();
});
